import cn from 'classnames/bind';
import * as React from 'react';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
class ItemRow extends React.Component {
    render() {
        const { className, flavor, children } = this.props;
        const childrenWithProps = React.Children.map(children, (child) => {
            // Handle null children (such as false JSX conditions)
            if (!child) {
                return null;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return React.cloneElement(child, {
                flavor,
            });
        });
        return (React.createElement("div", { className: cx(className, classes.container, flavor) }, childrenWithProps));
    }
}

export { ItemRow };
//# sourceMappingURL=index.js.map
